import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';
import * as moment from 'moment-timezone';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-select-t2-year',
  templateUrl: './select-t2-year.component.html',
  styleUrls: ['./select-t2-year.component.scss']
})
export class SelectT2YearComponent implements OnInit {

  public items: any[] = [];
  public months: any = [this.gasprecioService.capitalizeFirstLetter(moment().format('MMM YY'))];
  private lastMonthSelected: Subscription;
  first = true;
  format$!: Subscription
  format: number;
  idGroup;
  rol;
  showBurgos = false;
  showCombuexpress = false;
  showRendichicas = false;
  specialGroup = false;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService,
    private gasprecioService: GasprecioService
  ) {
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || '60afa99655f4ee369d1df409' : localStorage.getItem('group');
    this.showBurgos = this.idGroup === '652089ad94a59a35e91437da' || this.idGroup === '65c2849672bf4238ffccbe4c';
    this.showRendichicas = this.idGroup === '615efe30b318ce63b8971986';
    this.showCombuexpress = this.idGroup === '63fd4c8f1a5bfd390727f392';
    this.specialGroup = this.showBurgos || this.showRendichicas || this.showCombuexpress
  }

  ngOnInit(): void {
    const startDate = moment('2024-01-01');
    const endDate = moment().date() === 1 ? moment().subtract(1, 'day') : moment();
    if (startDate.isBefore(endDate)) {
      let date = startDate.clone().startOf('month');
      const endLimit = endDate.clone().endOf('month');
      while (date.isSameOrBefore(endLimit)) {
        this.items.push({
          name: this.gasprecioService.capitalizeFirstLetter(date.format('MMMM YY')),
          startDate: date.clone().startOf('month').format('YYYY-MM-DD'),
          endDate: date.clone().endOf('month').format('YYYY-MM-DD')
        });
        date = date.clone().add(1, 'month');
      }
      this.items.push({ name: 'No mostrar', startDate: null, endDate: null });
      this.items.reverse();

      this.lastMonthSelected = this.sharedService.sharedT2Dashboard2.subscribe((selectedMonth: string) => {
        const parsedMonth = selectedMonth ? moment(selectedMonth, 'YYYY-MM') : null;

        if (this.specialGroup) {
          if (!this.sharedService.t2Dashboard2UserSelected) {
            const defaultValue = endDate.clone().subtract(1, 'year').format('YYYY-MM');
            this.months = this.gasprecioService.capitalizeFirstLetter(moment(defaultValue).format('MMMM YY'));
            this.sharedService.nextT2Dashboard2 = defaultValue;
            return;
          }
          this.months = this.gasprecioService.capitalizeFirstLetter(parsedMonth?.format('MMMM YY'));
        } else {
          this.months = parsedMonth ? this.gasprecioService.capitalizeFirstLetter(parsedMonth.format('MMMM YY')) : this.gasprecioService.capitalizeFirstLetter(endDate.format('MMMM YY'));
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.lastMonthSelected) {
      this.lastMonthSelected.unsubscribe();
    }
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  changeMonthsAgo(event: any) {
    this.months = event;
    this.items.map((e) => {
      if (e.name === event) {
        this.sharedService.t2Dashboard2UserSelected = true;
        this.sharedService.nextT2Dashboard2 = e.startDate;
      }
    });
  }
}